import { render, staticRenderFns } from "./GiftCertificatesBanner.vue?vue&type=template&id=21cbbb4b&scoped=true&"
import script from "./GiftCertificatesBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GiftCertificatesBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GiftCertificatesBanner.vue?vue&type=style&index=0&id=21cbbb4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbbb4b",
  null
  
)

export default component.exports